const MODULE = "DICTIONARIES_VICTIMS_";

export const CHANGE_VALUE = `${MODULE}change-value`;
export type CHANGE_VALUE = typeof CHANGE_VALUE;

export const GET_ITEMS = `${MODULE}get-items`;
export type GET_ITEMS = typeof GET_ITEMS;

export const SEARCH = `${MODULE}search`;
export type SEARCH = typeof SEARCH;